import { render, staticRenderFns } from "./NoticeEditForm.vue?vue&type=template&id=29796784"
import script from "./NoticeEditForm.vue?vue&type=script&lang=js"
export * from "./NoticeEditForm.vue?vue&type=script&lang=js"
import style0 from "./NoticeEditForm.vue?vue&type=style&index=0&id=29796784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports